import {
  StoreEditorHistory,
  StoreEditorToolbar,
} from "@softmax/product-ux/editor";

import { useEditModeMaybe } from "./use-edit-mode-maybe";

export function EditBar({ coworldName }: { coworldName: string }) {
  const mode = useEditModeMaybe();

  if (!mode?.editing) return null;

  const { editor, exitEditing } = mode;
  const announcement =
    editor.lastAction === "published" || editor.lastAction === "pending_review"
      ? editor.lastAction
      : null;

  return (
    <StoreEditorToolbar
      coworldName={coworldName}
      loaded={editor.loaded}
      loading={editor.loading}
      dirty={editor.dirty}
      saving={editor.saving}
      publishing={editor.publishing}
      mutating={editor.mutating}
      canSave={editor.canSave}
      canPublish={editor.canPublish}
      awaitingReview={editor.status === "pending_review"}
      firstPublish={editor.firstPublishedAt === null}
      conflict={editor.conflict !== null}
      announcement={announcement}
      failure={editor.failure}
      validationErrors={editor.fieldErrors}
      onSave={() => void editor.save({})}
      onPublish={() => void editor.publish()}
      onExit={exitEditing}
      onKeepChanges={editor.resolveConflictKeepMine}
      onDiscardChanges={editor.resolveConflictTakeTheirs}
      onRetry={() => void editor.retry()}
      history={
        <StoreEditorHistory
          currentRevisionId={editor.currentRevisionId}
          revisions={editor.revisions.map((revision) => ({
            id: revision.id,
            version: revision.version,
            status: revision.status,
            createdAt: revision.created_at,
            note: revision.note,
          }))}
          busy={editor.loading || editor.mutating}
          canChangeRevision={editor.canWrite}
          failure={editor.failure}
          onRetry={() => void editor.retry()}
          reviewActions={
            mode.canReview
              ? {
                  approve: (id) => void editor.approve(id),
                  reject: ({ id, reason }) =>
                    void editor.reject({ revisionId: id, reason }),
                }
              : undefined
          }
          onRevert={(id) => {
            if (editor.dirty) {
              const confirmed = window.confirm(
                "Revert to this revision and discard your unsaved changes?",
              );

              if (!confirmed) return;
            }

            void editor.revert(id);
          }}
        />
      }
    />
  );
}
